export enum TextTone {
  DEFAULT = 'default',
  MUTED = 'muted',
  YES = 'yes',
  NO = 'no',
  MAYBE = 'maybe',
  ERROR = 'error',
  ANY = 'any',
  GHOST = 'ghost',
  INVERSE = 'inverse',
}
